import React from 'react';
import css from './OptionalBottomNavButtons.css';

import { Button, SecondaryButton, TertiaryButton } from '../../components';
import { ArrowNextIcon } from '../../icons';
import classNames from 'classnames';

export default ({ pristine, goBack, ...rest }) => {
    return (
        <>
            <TertiaryButton
                type="button"
                {...rest}
                className={classNames(css.optionalButton, css.backButton)}
                onClick={goBack}
            >
                Zurück
            </TertiaryButton>
            {pristine ? (
                <Button className={css.optionalButton} {...rest}>
                    Weiter <ArrowNextIcon />
                </Button>
            ) : (
                <SecondaryButton className={css.optionalButton} {...rest}>
                    Überspringen
                </SecondaryButton>
            )}
        </>
    );
};
